import { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { FormRow, Label, QueryDropdown } from 'basic-components';
import { DataStorageEnums } from 'dashboard-services/api/dataStorage';
import { DropdownService } from 'primary-components';

import properties from 'resources/constants/properties.json';

const emptyArray = []
const emptyObject = {}

const CurveDropdown = ({
  config,
  autoFocus = false,
  defaultValue = undefined,
  dropdownRef = undefined,
  enabled = true,
  getApiConfigLocal,
  groupName = undefined,
  index,
  onChange,
  priorMetadatas = emptyObject,
  priorMetadatasKey = '',
  queryClient,
  source = undefined,
  stateKey
}) => {
  const [valueQuery, setValueQuery] = useState(),
        localDropdownRef = useRef(),
        prevEnabledRef = useRef(enabled),
        resolvedDropdownRef = dropdownRef || localDropdownRef,
        isMetadata = !config.type || config.type === DataStorageEnums.KEY_TYPE.METADATA || config.type === 'METADATA',
        { fetchNextPage, isFetching, isFetchingNextPage, data: values = emptyArray } = DropdownService.useQuerySymbolValues({
          queryClient,
          input: valueQuery,
          key: config.filterKey,
          groupName,
          metadata: isMetadata,
          metadatas: priorMetadatas,
          useEs: properties.useEsSymbolListing === 'true',
          getApiConfig: getApiConfigLocal,
          enabled,
          provider: source,
          useV2: true
        }),
        onChangeValue = useCallback(value => {
          onChange(value, {
            config,
            index
          })
        }, [config, index, onChange])

  useEffect(() => {
    resolvedDropdownRef.current?.refreshOptions?.()
  }, [groupName, priorMetadatasKey, resolvedDropdownRef])

  useEffect(() => {
    if(defaultValue === undefined) {
      resolvedDropdownRef.current?.dropdown?.current?.setValue(defaultValue)
    }
  }, [defaultValue, resolvedDropdownRef])

  useEffect(() => {
    if(enabled && !prevEnabledRef.current && defaultValue === undefined) {
      window.setTimeout(() => resolvedDropdownRef.current?.dropdown?.current?.focus?.(), 0)
    }
    prevEnabledRef.current = enabled
  }, [defaultValue, enabled, resolvedDropdownRef])

  return (
    <FormRow
        className="ng-office-app__authed__content__body__item__curve-creator__row"
        isVertical
    >
      <Label id={config.filterKey}>{String(config.label || config.filterKey).toUpperCase()}</Label>
      <QueryDropdown
          autoFocus={autoFocus}
          defaultValue={defaultValue}
          disabled={!enabled}
          fetchNextPage={fetchNextPage}
          fixed
          isFetching={isFetching || isFetchingNextPage}
          labelId={config.filterKey}
          menuPlacement="bottom"
          menuPortalTarget={document.querySelector('.ng-office-app')}
          name={stateKey}
          noError
          onChange={onChangeValue}
          onInputChange={setValueQuery}
          openMenuOnFocus
          options={values}
          placeholder={config.placeholder || `Choose ${String(config.label || config.filterKey).toLowerCase()}`}
          ref={resolvedDropdownRef}
          variant="border"
      />
    </FormRow>
  )
}

CurveDropdown.propTypes = {
  autoFocus: PropTypes.bool,
  config: PropTypes.shape({
    filterKey: PropTypes.string.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    type: PropTypes.string
  }).isRequired,
  defaultValue: PropTypes.string,
  dropdownRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ]),
  enabled: PropTypes.bool,
  getApiConfigLocal: PropTypes.func.isRequired,
  groupName: PropTypes.string,
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  priorMetadatas: PropTypes.object,
  priorMetadatasKey: PropTypes.string,
  queryClient: PropTypes.any.isRequired,
  source: PropTypes.string,
  stateKey: PropTypes.string.isRequired
}

export default CurveDropdown
